import { gql } from '@apollo/client'
import React from 'react'
import { toDate } from '@ztechapps/common.utils'
import { FormModal, Field } from '@ztechapps/webui.form'
import { DateTimeInput } from '@ztechapps/webui.date'
import { AddNewToken } from './AddNewToken'
import { TextInput } from '@ztechapps/webui.input'
import { useError, useMutation } from '@ztechapps/common.hook'
import { Stack } from 'react-bootstrap'

export const AddFormModal = () => {
  const [onAdd, , { error }] = useMutation({ query: addTokenQuery, options: { mutationOptions: { refetchQueries: ['getApiLoginTokens'] } } })

  useError(error)

  const onSubmit = async (params) => {
    const { errors } = await onAdd({
      input: {
        ...params,

        scope: 'api',
      },
    })
    if (errors) throw errors
  }
  const validate = (values) => {
    const errors: any = {}

    if (!values.name) errors.name = 'Required'

    return errors
  }

  return (
    <FormModal
      {...{
        trigger: AddNewToken,
        initialValues: { name: 'New personal access token', when: toDate().add(1, 'year').toDate() },
        validate,
        onSubmit,
        title: 'New personal access token',
      }}
    >
      <Stack gap={2}>
        <Field name="name" help="Pick a name for the application, and we'll give you a unique personal access token." component={TextInput} />
        <Field
          name="when"
          label="Expires at"
          help="Pick a date on which the token will expire, making it empty sets the value to very distant future value."
          component={DateTimeInput}
          onChange
        />
        <Field
          name="hashedToken"
          label="Token String"
          help="You can leave this blank and we will generate one for you automatically."
          component={TextInput}
        />
      </Stack>
    </FormModal>
  )
}

const addTokenQuery = gql(`
  mutation createApiLoginToken($input: JSON!) {
    createApiLoginToken(input: $input) {
      hashedToken
      when
      name
      scope
    }
  }
`)
